import Logo from './logo-extension';
import { componentFactory, getValidValue } from '../../../fc-core/src/lib';

var isRequiredComponent = function isRequiredComponent(a, b) {
  return a.getType() === b;
};

export default {
  extension: function extension(a) {
    a.addEventListener('instantiated', function (a) {
      var b = a.sender;
      isRequiredComponent(b, 'chartAPI') && b.registerFactory('logo', function (a) {
        var b = a.getFromEnv('chart-attrib'),
            c = getValidValue(b.logourl, '');
        componentFactory(a, Logo, 'logo', c ? 1 : 0, [b]);
      });
    });
  },
  name: 'LogoExtension',
  type: 'extension',
  requiresFusionCharts: !0
};